import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import FavIcon from "../common/assets/favicon.png";

import "./index.scss";

const Layout = ({ children }) => (
	<div>
		<Helmet
			title="Julie Kuang Design Portfolio"
			meta={[
				{
					name: "description",
					content: "Julie Kuang's online portfolio. User Experience and Visual Designer.",
				},
				{
					name: "keywords",
					content:
						"Julie Kuang, portfolio, visual designer, user interface, user experience, ui, ue",
				},
			]}
		>
			<link rel="icon" type="image/png" href={FavIcon} />
		</Helmet>
		<div id="content">
			{children()}
		</div>
	</div>
);

Layout.propTypes = {
	children: PropTypes.func,
};

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.js